module.exports = __webpack_public_path__ + "img/home-nav-icon-5.1835cdeb.png";